import { render, staticRenderFns } from "./RequestAccount.vue?vue&type=template&id=3b3d4ba9&scoped=true&"
import script from "./RequestAccount.vue?vue&type=script&lang=js&"
export * from "./RequestAccount.vue?vue&type=script&lang=js&"
import style0 from "./RequestAccount.vue?vue&type=style&index=0&id=3b3d4ba9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3d4ba9",
  null
  
)

export default component.exports